import React, { useState } from 'react';
import { Colors, DownloadFile, getFreshFileUrl, Images } from 'utils';
import { MinLoader } from 'components';

export const DownloadEob = ({ file }) => {
    const { loadDownload, handleDownload } = DownloadFile();
    const [previewLoader, setPreviewLoader] = useState(false);

    if (!file) return null;

    const handleShow = async () => {
        setPreviewLoader(true);
        try {
            const url = await getFreshFileUrl(file, { disposition: 'inline' });
            if (url) {
                window.open(url, '_blank', 'noopener,noreferrer');
            }
        } finally {
            setPreviewLoader(false);
        }
    };

    return (
        <div className="flex-align-center" style={{ gap: 12 }}>
            <button onClick={() => handleDownload(file)} className="download-1500">
                <p>Download</p>
                {loadDownload ? (
                    <MinLoader margin={'0 0 0 3px'} color={Colors.ThemeBlue} position={'relative'} width={15} height={15} />
                ) : (
                    <img src={Images.downloadCloudBlue} alt="download" />
                )}
            </button>

            <button onClick={handleShow} className="reset-btn-by-default" style={{ height: 15, width: 15 }}>
                {previewLoader ? (
                    <MinLoader color={Colors.ThemeBlue} small={true} margin={'0'} position={'relative'} />
                ) : (
                    <img src={Images.showAyeBlue} alt="show" />
                )}
            </button>
        </div>
    );
};
